import { Button, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/store";
const AppBarLabel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticate = useSelector((state)=> state.auth.isAuthenticate);
  // const isCognitoAuthenticated = useSelector((state)=> state.auth.isCognitoAuthenticated);
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/cognito-login");
  };
  return (
    <Toolbar>
      <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
        {props.label}
      </Typography>
      {!isAuthenticate && <Button color="inherit">Login</Button>}
      {isAuthenticate && (
        <Button onClick={logoutHandler} color="inherit">
          Logout
        </Button>
      )}
    </Toolbar>
  );
};

export default AppBarLabel;
